import React from "react";
import "../../../../css/AreaGobierno/tribunal-de-cuentas.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";

const memorias = [
  {
    url: "https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/tribunal-cuentas/memoria/Acta-de-Constitucion.pdf",
    text: "ACTA CONSTITUTIVA 03/12/2019"
  },
  {
    url: "https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/tribunal-cuentas/memoria/Acta-274-Fijan-domicilio.pdf",
    text: "ACTA 274 FIJACIÓN DE DOMICILIO"
  },
  {
    url: "https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/tribunal-cuentas/memoria/Acta-Informe-Cta-Gral-del-Ejercicio-2020.pdf",
    text: "ACTA DICTAMEN CUENTA GENERAL DEL EJERCICIO 2020"
  },
  {
    url: "https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/tribunal-cuentas/memoria/Acta-Informe-Cta-Gral-del-Ejercicio-2021.pdf",
    text: "ACTA DICTAMEN CUENTA GENERAL DEL EJERCICIO 2021"
  },
  {
    url: "https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/tribunal-cuentas/memoria/Acta-329-Eleccion-de-Autoridades.pdf",
    text: "ACTA 329 ELECCION DE AUTORIDADES"
  }
];

const MemoriasTribunal = () => (
  <div className="memorias-tribunal-bg">
    <div className="memorias-tribunal-container">
      <h1>MEMORIAS TRIBUNAL DE CUENTAS</h1>
      <div className="row justify-content-center">
        {memorias.map((memoria, idx) => (
          <div className="col-md-4 col-sm-6 col-12 mb-4 d-flex align-items-stretch" key={idx}>
            <a
              href={memoria.url}
              target="_blank"
              rel="noopener noreferrer"
              className="memoria-btn w-100 d-flex flex-column align-items-center justify-content-center"
            >
              <span className="memoria-btn-text text-center">
                <FontAwesomeIcon icon={faPaperclip}/>&nbsp;
                {memoria.text}
                </span>
            </a>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default MemoriasTribunal;